import { render, staticRenderFns } from "./HMTabs.vue?vue&type=template&id=aa4825cc&scoped=true&"
import script from "./HMTabs.vue?vue&type=script&lang=ts&"
export * from "./HMTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HMTabs.vue?vue&type=style&index=0&id=aa4825cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4825cc",
  null
  
)

export default component.exports